module.exports = function _isPlaceholder(a) {
  return a != null &&
         typeof a === 'object' &&
         a['@@functional/placeholder'] === true;
};



//////////////////
// WEBPACK FOOTER
// /home/deploy/7n_staging/shared/~/ramda/src/internal/_isPlaceholder.js
// module id = 32
// module chunks = 0 1 2 3 4 5 6 7